api = require('../api.coffee').api()

class global.ContactSpecificTemplatesResource extends ResourceBase
  @MODEL = ContactSpecificTemplate
  @SINGULAR_RESOURCE_NAME = 'template'
  @PLURAL_RESOURCE_NAME = 'templates'

  constructor: (company_id, flow_id) ->
    @company_id = company_id
    @flow_id = flow_id

  basePath: ->
    "/flows/#{@flow_id}/contact_specific_templates"

  index: (success, failure, params = {}) ->
    api.get @basePath(), params, { success: @collectionSuccess(success), failure }



// WEBPACK FOOTER //
// ./src/resources/contact_specific_templates.coffee